// Flex
import Flex from '@/components/Flex.vue'
import FlexItem from '@/components/FlexItem.vue'

// Components
import Page from '@/components/Page.vue'
import NavBar from '@/components/NavBar.vue'
import Container from '@/components/Container.vue'
import ArticleLink from '@/components/ArticleLink.vue'

// Form
import RadLink from '@/components/RadLink.vue'
import RadButton from '@/components/RadButton.vue'

// Code
import CodeDemo from '@/components/CodeDemo.vue'
import CodeExample from '@/components/CodeExample.vue'
import CodeSnippet from '@/components/CodeSnippet.vue'

// Glossary
import GlossaryRow from '@/components/GlossaryRow.vue'
import GlossaryTable from '@/components/GlossaryTable.vue'

// Sections
import SectionHero from '@/components/sections/SectionHero.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import SectionFooter from '@/components/sections/SectionFooter.vue'
import SectionContent from '@/components/sections/SectionContent.vue'
import SubSectionTitle from '@/components/SubSectionTitle.vue'

export default {
  // Flex
  Flex,
  FlexItem,

  // Components
  Page,
  NavBar,
  Container,
  ArticleLink,

  // Form
  RadLink,
  RadButton,

  // Code
  CodeDemo,
  CodeExample,
  CodeSnippet,

  // Glossary
  GlossaryRow,
  GlossaryTable,

  // Sections
  SectionHero,
  SectionTitle,
  SectionFooter,
  SectionContent,
  SubSectionTitle
}
